import React, { FC } from 'react'
import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'
import { Button } from '@mui/material'
import { TranslatedTextType } from '../../hooks/shared'

interface ButtonNext {
  buttonText: TranslatedTextType
  customClassName?: string
  disabled?: boolean
  outlined?: boolean
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  handleClick?(): void
  testId?: string
  id?: string
}

const useStyles = makeStyles<{ outlined: boolean }>()((theme: Theme, { outlined }) => ({
  buttonNext: {
    fontSize: '1rem',
    backgroundColor: outlined ? theme.palette.secondary.contrastText : theme.palette.primary.main,
    color: outlined ? theme.palette.primary.main : theme.palette.secondary.contrastText,
    border: outlined ? `1px solid ${theme.palette.primary.main}` : 'none',
    boxShadow: outlined && 'none',
    [theme.breakpoints.up('md')]: {
      maxWidth: '345px',
    },
    margin: '0 auto',
  },
}))

const FSMBtnNext: FC<ButtonNext> = ({
  buttonText,
  customClassName,
  disabled = false,
  outlined = false,
  startIcon,
  endIcon,
  id = 'next-button',
  handleClick,
  testId = 'FSMBtnNext',
}) => {
  const { classes, cx } = useStyles({ outlined })
  const variant = outlined ? 'outlined' : 'contained'

  return (
    <Button
      id={id}
      data-testid={testId}
      disabled={disabled}
      onClick={handleClick}
      variant={variant}
      size='medium'
      className={cx(classes.buttonNext, customClassName)}
      fullWidth
      startIcon={startIcon}
      endIcon={endIcon}
    >
      {buttonText}
    </Button>
  )
}

export default FSMBtnNext
